import React from 'react';
import { useTranslation } from 'react-i18next';
import useUserCapability from 'sharedHooks/useUserCapability';

const EnvironmentSensorsHeaderComponent = () => {
    const { t: translate } = useTranslation();
    const userCapability = useUserCapability();
    const hasGatewayAdminViewCapability = userCapability?.hasGatewayAdminViewCapability?.() === true;
    const hasGatewayAdminReadViewCapability = userCapability?.hasGatewayAdminReadView?.() === true;
    const isGatewayReadOnlyMode = hasGatewayAdminReadViewCapability && !hasGatewayAdminViewCapability;
    return (
        <div className='environment-sensor-list__header'>
            <div className='environment-sensor-list__cell environment-sensor-list__cell--sticky' id='environment-sensor-head__serialnumber'>{translate('ABB.Powertrain.Frontend.serialNumberLabel')}</div>
            <div className='environment-sensor-list__cell' id='environment-sensor-head__last-signal-received'>
                {translate('ABB.Powertrain.Frontend.environmentSensorsLastSignalReceived')}
            </div>
            {!isGatewayReadOnlyMode &&
                <div className='environment-sensor-list__cell' id='environment-sensor-head__disconnect-sensor'>
                </div>}
        </div>
    );
};

export default EnvironmentSensorsHeaderComponent;
